import React from 'react'
import { Prompt } from 'react-router'

import { Routes } from '../../Routes'
import { useBreakpoint } from '../BreakpointProvider'

const ResponsiveSettingsContext = React.createContext(null)

const ResponsiveSettingsProvider = ({ children }) => {
  const { isExtraSmall, down429} = useBreakpoint()

  const [selecting, setSelecting] = React.useState(true)

  const handleNavigation = React.useCallback(location => {
    const { pathname } = location

    // Reset state when navigating away
    if (!pathname.startsWith(Routes.SETTINGS)) {
      setSelecting(true)
    }

    return true
  }, [])

  return (
    <ResponsiveSettingsContext.Provider
      value={{ selecting, setSelecting, isSmall: isExtraSmall, isExtraSmall:down429 }}
    >
      {children}

      <Prompt message={handleNavigation} when={true} />
    </ResponsiveSettingsContext.Provider>
  )
}

export default ResponsiveSettingsProvider

export const useResponsiveSettings = () =>
  React.useContext(ResponsiveSettingsContext)
